import react, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridValueGetterParams, getGridStringOperators, } from "@mui/x-data-grid";
import { Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem, InputLabel, FormControl, Paper, Grid, Chip, Divider } from "@mui/material";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import styled from "styled-components";
import todayCalanerImage from "../../icons/todaysCalander.svg"
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, IconButton, InputAdornment, TextField, Stack, Box } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Add, Save, SaveAlt, Search } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import OrderLineItemModal from "../../components/modals/orderLineItemModal";
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PartyList from "../../components/modals/partyListModal";
import AddRoutePlan from "../../components/modals/addRoutePlan";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import TodayRoutePlanModal from "../../components/modals/TodayRoutePlanModal";
import AddTicketModal from "../../components/modals/AddTicketModal";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  min-height: calc(100vh - 105px);
  width: 100%;
  background-color: #f7f9fc;
  padding: 16px clamp(10px, 2vw, 24px) 24px;
  box-sizing: border-box;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
`;

const TableContainer = styled.div`
  width: 100%;
  border-radius: 12px;
`;

const DataGridContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  min-height: 320px;
  border: solid 1px #e3e8ef;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;
`;

const StatCard = ({ icon, label, value, accent, suffix }) => (
    <Paper
        elevation={0}
        sx={{
            p: 2,
            height: "100%",
            borderRadius: "14px",
            border: "1px solid #e3e8ef",
            borderLeft: `4px solid ${accent}`,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            transition: "box-shadow 0.2s ease, transform 0.2s ease",
            "&:hover": {
                boxShadow: "0 6px 18px rgba(20, 30, 60, 0.08)",
                transform: "translateY(-2px)",
            },
        }}
    >
        <Box
            sx={{
                width: 44,
                height: 44,
                minWidth: 44,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: `${accent}1A`,
                color: accent,
            }}
        >
            {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: 0.4 }}>
                {label}
            </Typography>
            <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#111827", lineHeight: 1.3 }}>
                {value}
                {suffix ? <Typography component="span" sx={{ fontSize: 13, fontWeight: 500, color: "#6b7280", ml: 0.5 }}>{suffix}</Typography> : null}
            </Typography>
        </Box>
    </Paper>
);

export default function TicketManagement() {
    const label = { inputProps: { "aria-label": "Checkbox demo" } };
    const [loading, setLoading] = useState(false);
    const [accessChanges, setAccessChanges] = useState("");
    const [showWarehouseFormModal, setShowWarehouseFormModal] = useState();
    const [modal, setModal] = useState(false)
    const [modalData, setModalData] = useState()
    const [addModal, setAddModal] = useState(false)
    const [rowCount, setRowCount] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
    const [newOrderStatus, setNewOrderStatus] = useState(0);
    const [filter, setFilter] = useState(false)
    const [searchTerm, setSearchTerm] = useState(null)
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [accessModulesData, setAccessModulesData] = useState([]);
    const [dateRange1, setDateRange1] = useState(false)
    const [startDate1, setStartDate1] = useState()
    const [endDate1, setEndDate1] = useState()
    const [minDate, setMinDate] = useState()
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [callApi, setCallApi] = useState(false);
    const [fromDate, setFromDate] = useState("")
    const [openDialog, setOpenDialog] = useState(false);
    const [reason, setReason] = useState("");
    const [rejectData, setRejectData] = useState(null);
    const [editMode, setEditMode] = useState(false)
    const [editModalData, setEditModalData] = useState({})
    const [partyList, setPartyList] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)

    const [ticketDetailOpen, setTicketDetailOpen] = useState(false);
    const [ticketDetailData, setTicketDetailData] = useState(null);

    const TOTAL_YEARLY_HOURS = 384;
    const [hoursStats, setHoursStats] = useState({
        totalYearly: TOTAL_YEARLY_HOURS,
        used: 0,
        pending: TOTAL_YEARLY_HOURS,
        thisMonthUsed: 0,
    });

    const formatDateTime = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        if (isNaN(inputDate.getTime())) {
            return 'Invalid Date';
        }
        const year = inputDate.getUTCFullYear();
        const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getUTCDate()).padStart(2, '0');
        const hours = String(inputDate.getUTCHours()).padStart(2, '0');
        const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
        const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');
        const formattedDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return formattedDateString;
    }
    const [sessions, setSessions] = useState([]); // from API
    const [selectedSession, setSelectedSession] = useState("");
    const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
    const [isSessionDisabled, setIsSessionDisabled] = useState(false);
    const [filteredDate, setFilteredData] = useState({})

    const fetchSessions = async () => {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            if (response?.status) {
                const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
                setFilteredData(filterdData1[0])
            }
            else {
                window.NotificationUtils.showError("Something Went Wrong in session")
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
            fetchOrder()
    }, [paginationModel.page, newOrderStatus, paginationModel.pageSize]);

    const fetchOrder = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                status: newOrderStatus,
                startDate: startDate != '' ? startDate : filteredDate?.startDate,
                endDate: endDate != '' ? endDate : filteredDate?.endDate,
            }
            let results = await window.Platform.database.getAllTickets(data);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
            setRowCount(results.data1)
            setAccessChanges(jsonArrayWithId);
            computeHoursStatsFromRows(jsonArrayWithId);
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Error Fetching Data");
        }
        finally {
            setLoading(false)
        }
    }

    const onFilterChange = async (filterModel) => {
        try {
            setLoading(true);
            setFilter(true)
            if (filterModel) {
                const response = await window.Platform.database.filterRoutePlan({ filterField: filterModel.field, filterValue: filterModel.value, pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
                const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
                setAccessChanges(jsonArrayWithId)
                setRowCount(response.data1)
            }
            else {
                const response = await window.Platform.database.filterRoutePlan({ filterField: "date", pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
                const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
                setAccessChanges(jsonArrayWithId)
                setRowCount(response.data1)
            }
            setLoading(false);
        }
        catch (err) {
            console.error(err)
            setLoading(false);
            window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
        }
    };

    useEffect(() => {
        fetchAccessModules();
        fetchSessions();
        fetchHoursStats();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const formatted = tomorrow.toISOString().split("T")[0];
        setStartDate(formatted);
        setEndDate(formatted);
    }, []);

    const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId: userData?.id,
                moduleId: "wzxRdAWFxJ"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

    // ---- Hours summary fetch/compute --------------------------------------
    const fetchHoursStats = async () => {
        try {
            // Preferred path: ask the backend for the real numbers.
            // If this endpoint doesn't exist in your API yet, this call will
            // throw/return falsy and we silently fall back below.
            if (window.Platform?.database?.getTicketHoursSummary) {
                const res = await window.Platform.database.getTicketHoursSummary({ userId: userData?.id });
                if (res?.status === false && res?.data) {
                    const used = Number(res.data.used) || 0;
                    setHoursStats({
                        totalYearly: TOTAL_YEARLY_HOURS,
                        used,
                        pending: Math.max(TOTAL_YEARLY_HOURS - used, 0),
                        thisMonthUsed: Number(res.data.thisMonthUsed) || 0,
                    });
                    return;
                }
            }
        } catch (error) {
            console.log("No hours summary endpoint yet, falling back to local calc:", error);
        }
        // Fallback: nothing from backend yet, keep defaults until rows load.
    };

    const computeHoursStatsFromRows = (rows) => {
        if (!rows || !rows.length) return;
        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();

        // FIELD NAME: change `row?.hours` below to match your actual ticket
        // schema (e.g. row?.duration, row?.consumedHours, etc.)
        const thisMonthUsed = rows.reduce((sum, row) => {
            const rowDate = row?.date ? new Date(row.date) : null;
            const rowHours = Number(row?.hours) || 0;
            if (rowDate && rowDate.getMonth() === currentMonth && rowDate.getFullYear() === currentYear) {
                return sum + rowHours;
            }
            return sum;
        }, 0);

        setHoursStats((prev) => ({
            ...prev,
            thisMonthUsed: thisMonthUsed || prev.thisMonthUsed,
        }));
    };

    const getEmployeeColumns = () => {
        const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));

        let result = [
              {
                field: "CreatedBY",
                headerName: "Created By",
                width: 150,
                sortable: false,
                filterOperators: stringOperators,
                valueGetter: (params) => {
                  return (params.row.userName || "N/A");
                },
                renderCell: (params) => {
                  let name = params.row?.userName || "N/A"
                  return (
                    <Tooltip title={name || "N/A"}>
                      <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                    </Tooltip>
                  )
                },
              },
            {
                field: "Approve Order",
                headerName: "Actions",
                width: 170,
                filterable: false,
                sortable: false,
                disableExport: true,
                renderCell: (params) => {
                    let value = params.row?.routeId
                    let value1 = formatToOnlyDate(params.row?.date)
                    let ownerId = params.row?.ownerId
                    return (
                        <Stack direction={"row"} spacing={0}>
                            <Tooltip title="View ticket details">
                                <IconButton variant="extended" color="primary" onClick={(e) => {
                                    e.stopPropagation();
                                    viewTicketDetails(params.row);
                                }}>
                                    <InfoOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            {accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no" && (newOrderStatus == "0") && (
                                <Tooltip title="Click to approve route-plan">
                                    <IconButton disabled={params.row?.status === 1 || params.row?.status === 2} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                                        e.stopPropagation();
                                        approveRejectOrder({ id: value, approvalStatus: "1" });
                                    }}>
                                        <ThumbUpIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no" && (
                                <Tooltip title="Click to edit route-plan">
                                    <IconButton variant="extended" onClick={(e) => { editData(params.row); }}>
                                        <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "400" }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Stack>
                    )
                },
            },
        ];
        return result
    }

    const viewTicketDetails = (row) => {
        setTicketDetailData(row);
        setTicketDetailOpen(true);
    };

    const editData = async (data) => {
        setEditModalData(data)
        setEditMode(true)
        try {
            let results = await window.Platform.database.getRouteplanById({ id: data?.routeId });

            if (results.status == false) {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
                setPartyList(jsonArrayWithId)
            }
            else {
                console.log("results=======", results);
                window.NotificationUtils.showError("Something Went Wrong!")
            }
        }
        catch (error) {
            console.log(error)
            window.NotificationUtils.showError("Something Went Wrong!")
        }
    }

    const approveRejectOrder = async (val) => {
        try {
            let message = val.approvalStatus == "1" ? "Route plan approved successfully" : "Route plan rejected successfully";
            setLoading(true);
            let payload = {
                id: val?.id,
                approvalStatus: val?.approvalStatus,
                isDirectApproval: true,
                reason: val?.reason
            }
            const results = await window.Platform.database.approvePartialRouteNotification(payload)
            if (results.status) {
                window.NotificationUtils.showError(results.message);
                setLoading(false)
                return;
            }
            window.NotificationUtils.showSuccess(message);
            setLoading(false)
            fetchOrder()
        }
        catch (err) {
            console.log(err)
            window.NotificationUtils.showError("Something Went Wrong!")
            setLoading(false)
        }
    }

    const formatTimeStamp = (timestampFromDB) => {
        const options = {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        };
        const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);
        return formattedDate;
    };

    const formatToOnlyDate = (val) => {
        const concertDate = new Date(val);
        const year = concertDate.getFullYear();
        const month = concertDate.getMonth() + 1;
        const day = concertDate.getDate();
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
        return formattedDate;
    }

    const getRouteplanById = async (val, val1, ownerId) => {
        try {
            setLoading(true)
            setModalData()
            let sentData = { id: val }
            let results = await window.Platform.database.getRouteplanById(sentData);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

            setModalData({ data: jsonArrayWithId, id: val, date: val1, ownerId: ownerId })
            setModal(true)
            setLoading(false)
        }
        catch (error) {
            console.log(error)
            window.NotificationUtils.showError("Something Went Wrong!")
            setLoading(false)
        }
    }

    function CustomToolbar() {
        return (
            <div>
                <GridToolbarContainer>
                    <Typography variant="body1" className="ml-4" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                    <Select
                        value={paginationModel.pageSize}
                        variant="outlined"
                        size="small"
                        onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                        sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
                    >
                        {[10, 20, 30, 50, 100].map((role) => (
                            <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role}</MenuItem>
                        ))}
                    </Select>
                </GridToolbarContainer>
            </div>
        );
    }

    const renderContent = () => {
        return (
            <DataGridContainer style={{ height: !accessChanges?.length ? '220px' : '620px' }}>
                <DataGrid
                    className="payrollGrid"
                    density="compact"
                    rows={accessChanges}
                    columns={getEmployeeColumns()}
                    sx={{
                        color: "black",
                        fontSize: "14px",
                        fontWeight: "600",
                        border: "none",
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: "#f3f5f9",
                            borderRadius: 0,
                        },
                    }}
                    disableSelectionOnClick
                    disableRowSelectionOnClick
                    disableDensitySelector
                    rowHeight={60}
                    pageSizeOptions={[10]}
                    onFilterModelChange={(val) => {
                        if (val?.items[0]?.value?.length > 0) {
                            onFilterChange(val.items[0])
                            setSearchTerm(val.items[0])
                        }
                        else if (!val.items[0]?.value && startDate && endDate) {
                            setSearchTerm(null)
                            onFilterChange()
                        }
                        else {
                            fetchOrder()
                            setSearchTerm(null)
                            setFilter(false)
                        }
                    }}
                    filterMode="server"
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </DataGridContainer>
        );
    };

    const statusLabel = (status) => {
        if (status === 1) return { text: "Approved", color: "#16a34a" };
        if (status === 2) return { text: "Rejected", color: "#dc2626" };
        return { text: "Pending", color: "#d97706" };
    };

    return (
        <>
            {loading && <OpaqueLoading />}
            <StaffEditorPageContainer>
                <HeaderContainer>
                    <Box>
                        <Typography sx={{ fontSize: { xs: 20, sm: 24 }, fontWeight: 700, color: "#111827" }}>
                            Ticket Management
                        </Typography>
                        <Typography sx={{ fontSize: 13, color: "#6b7280" }}>
                            Track, add, update, and review tickets and route plans
                        </Typography>
                    </Box>
                    {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setAddModal(true)}
                            sx={{ borderRadius: '10px', textTransform: "none", fontWeight: 600, width: { xs: "100%", sm: "auto" } }}
                        >
                            <Add sx={{ mr: 1 }} /> Add / Update Ticket
                        </Button>
                    )}
                </HeaderContainer>

                {/* ---- Hours summary dashboard ---- */}
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <StatCard
                            icon={<AccessTimeIcon />}
                            label="Total Yearly Hours"
                            value={hoursStats.totalYearly}
                            suffix="hrs"
                            accent="#2563eb"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <StatCard
                            icon={<TaskAltIcon />}
                            label="Used"
                            value={hoursStats.used}
                            suffix="hrs"
                            accent="#16a34a"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <StatCard
                            icon={<HourglassBottomIcon />}
                            label="Pending"
                            value={hoursStats.pending}
                            suffix="hrs"
                            accent="#d97706"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <StatCard
                            icon={<CalendarMonthIcon />}
                            label="Used This Month"
                            value={hoursStats.thisMonthUsed}
                            suffix="hrs"
                            accent="#7c3aed"
                        />
                    </Grid>
                </Grid>

                <TableContainer>{renderContent()}</TableContainer>
            </StaffEditorPageContainer>

            {/* ---- View Ticket Details modal ---- */}
            <Dialog open={ticketDetailOpen} onClose={() => setTicketDetailOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle sx={{ fontWeight: 700 }}>Ticket Details</DialogTitle>
                <DialogContent dividers>
                    {ticketDetailData && (
                        <Stack spacing={1.5}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontSize: 13, color: "#6b7280" }}>Ticket / Route ID</Typography>
                                <Typography sx={{ fontWeight: 600 }}>{ticketDetailData?.routeId ?? "—"}</Typography>
                            </Box>
                            <Divider />
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontSize: 13, color: "#6b7280" }}>Date</Typography>
                                <Typography sx={{ fontWeight: 600 }}>
                                    {ticketDetailData?.date ? formatToOnlyDate(ticketDetailData.date) : "—"}
                                </Typography>
                            </Box>
                            <Divider />
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontSize: 13, color: "#6b7280" }}>Status</Typography>
                                <Chip
                                    label={statusLabel(ticketDetailData?.status).text}
                                    size="small"
                                    sx={{
                                        fontWeight: 600,
                                        color: statusLabel(ticketDetailData?.status).color,
                                        backgroundColor: `${statusLabel(ticketDetailData?.status).color}1A`,
                                    }}
                                />
                            </Box>
                            {ticketDetailData?.description && (
                                <>
                                    <Divider />
                                    <Box>
                                        <Typography sx={{ fontSize: 13, color: "#6b7280", mb: 0.5 }}>Description</Typography>
                                        <Typography sx={{ fontSize: 14 }}>{ticketDetailData.description}</Typography>
                                    </Box>
                                </>
                            )}
                        </Stack>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTicketDetailOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            {
                modal && <PartyList
                    onCancel={() => { setModal(false); fetchOrder(); }}
                    loading={loading}
                    data={modalData}
                    routeId={modalData?.id}
                    routeDate={modalData?.date}
                    ownerId={modalData?.ownerId}
                    getRouteplanById={getRouteplanById} />
            }
            {
                addModal && <AddTicketModal onClose={() => setAddModal(false)} fetchData={() => fetchOrder()} routeDate={modalData?.date} />
            }

            {
                editMode && <AddTicketModal onClose={() => setEditMode(false)} fetchData={() => fetchOrder()} editMode={editMode} editModalData={editModalData} partyList={partyList} />
            }
        </>
    );
}